import React, { memo, useLayoutEffect, useState } from 'react';
import { Bubble, Input } from 'tea-component';
import DropDownSelect from '@gp/components/DropDownSelect';
import { getEditableStaffSearchList } from '@gp/services/projectDetail';
import EditUserInfo from '@gp/components/EditUserInfo';
import { reportOperationLog } from '@gp/services/global';
import { useMemoizedFn } from 'ahooks';

interface PropsType {
  className?: string,
  defaultValue: {
    user_id: string,
    name: string,
  },
  isInput: boolean, // 是否为输入框，输入框时onChange传的值为string类型
  isError?: boolean, // 是否人员重复报错
  onChange: (
    data: {
      disabled: boolean,
      value: string,
      text: any,
      data: {
        user_name: string,
        user_id: string,
      },
    } | string,
  ) => void,
}

function index(props: PropsType) {
  const {
    defaultValue,
    isInput,
    isError,
    onChange,
  } = props;

  const [errorVisible, setErrorVisible] = useState<boolean>(false);
  const [options, setOptions] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<string | undefined>(undefined);

  const handleSearchValueChange = useMemoizedFn((payload: string) => {
    setSearchValue(payload || '');
  });

  const handleAddresseeSearch = useMemoizedFn((data: any, keyword: string) => {
    keyword && reportOperationLog({
      query: keyword,
      extInfo: '500501', // 当前页面id
      clickId: '',
      uidType: '',
      uid: '',
    }, 'search');
    const newOptions = data?.map((t: any) => {
      return ({
        value: t?.user_id,
        text: (<EditUserInfo highlightText={searchValue} text={t?.user_name} />),
        disabled: false,
        data: {
          user_name: t?.user_name,
          user_id: t?.user_id,
        },
      });
    });
    setOptions(newOptions);
  });

  // 设置默认的options
  useLayoutEffect(() => {
    if (defaultValue?.user_id && !isInput) {
      setOptions([
        {
          value: defaultValue?.user_id,
          text: (<EditUserInfo text={defaultValue?.name} />),
          disabled: false,
          data: {
            user_name: defaultValue?.name,
            user_id: defaultValue?.user_id,
          },
        },
      ]);
    }
  }, [defaultValue]);

  return (
    <Bubble
      error={isError}
      visible={errorVisible}
      content={isError ? `Duplicate name, please ${isInput ? 'reinput' : 'reselect'}` : undefined}
      trigger="hover"
      onVisibleChange={(v) => {
        setErrorVisible(v && !!isError);
      }}
    >
      {/* 报错提示增加class error */}
      <div>
        {isInput
          ? (
            <Input
              // 这个input需要跟下面的一样增加个报错的class
              className={`${isError ? 'error' : ''}`}
              placeholder="Please input Owner"
              defaultValue={defaultValue?.name}
              onChange={(value: string) => {
                onChange(value);
              }}
            />
          )
          : (
            <DropDownSelect
              className={`dbg-update-edit-selector ${isError ? 'error' : ''}`}
              allOpt={{
                placeholder: 'Please select Owner',
                searchPlaceholder: 'Search',
                clearable: false,
                searchable: true,
                searchValue,
                onSearchValueChange: handleSearchValueChange,
                staging: false,
                isCustomButtonCtx: false,
                defaultValue: defaultValue?.user_id,
                options,
                services: getEditableStaffSearchList,
                paramFormat: {
                  // 搜索时接口参数格式
                  keys: ['sub_name'],
                  params: {
                    cond_name: 'user',
                    sub_name: '',
                    studio_id: '',
                  },
                },
              }}
              onChange={(data: any) => {
                onChange(data?.options?.[0]);
              }}
              onSuccessSearch={handleAddresseeSearch}
              listWidth="270px"
            // getButtonCtx={() => {
            //   return <EditUserInfo />;
            // }}
            />
          )}
      </div>
    </Bubble>
  );
}

export default memo(index);
